import { ApiService } from '../../services/ApiService';

export interface ObjectDefinition {
  id: number;
  label: string;
  tableName: string;
  description?: string;
  baseUrl?: string;
}

export interface ObjectFieldDefinition {
  id: number;
  fieldName: string;
  fieldLabel: string;
  fieldType: string;
  readOnly: boolean;
}

export interface FieldOption {
  value: string;        // "client.name" (storage format)
  label: string;        // "Client Name" (display only - no prefix)
  objectTable: string;  // "client"
  objectLabel: string;  // "Client"
  fieldName: string;    // "name"
}

export class ObjectService {
  /**
   * Get all searchable objects
   */
  static async getObjects(): Promise<ObjectDefinition[]> {
    try {
      const response = await ApiService.apiGet('/objects');
      
      // Handle response structure: { data: { objects }, success }
      if (response.success && response.data) {
        return Array.isArray(response.data.objects) ? response.data.objects : [];
      } else {
        // // Error: Failed to fetch objects
        return [];
      }
    } catch (error) {
      // // Error: Failed to fetch objects
      return [];
    }
  }

  /**
   * Get fields for a specific object table
   */
  static async getObjectFields(tableName: string): Promise<ObjectFieldDefinition[]> {
    try {
      const response = await ApiService.apiGet(`/objects/${tableName}/fields`);
      
      // Handle response structure: { data: { fields }, success }
      if (response.success && response.data) {
        return Array.isArray(response.data.fields) ? response.data.fields : [];
      } else {
        // // Error: Failed to fetch fields for table
        return [];
      }
    } catch (error) {
      // // Error: Failed to fetch fields for object
      return [];
    }
  }



}